// Heading + subtitle for the "Insurance Solutions We Offer" homepage section.
// STATIC, code-managed. Extra bottom padding separates the intro from the cards.
function FirstComponent() {
    return (
        <div className="offers" style={{ paddingBottom: "2.5em" }}>
            <div className="offer-content">
                <h2 className="offer-heading">Insurance Solutions We Offer</h2>
                <p className="text-center" style={{ maxWidth: "720px", margin: "0 auto" }}>
                    GM Insurance Services helps California families and businesses compare coverage
                    options for personal, commercial, and business insurance needs.
                </p>
            </div>
        </div>
    );
}

export default FirstComponent;
